// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_UploadRefundReceiptInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/upload_refund_receipt
 *
 * Validates input for uploading a refund receipt.
 * Multipart form: file (file field only).
 */
import { registerContract } from './validate'

export interface Payroll_UploadRefundReceiptInput {
_files: unknown[]
}

registerContract('Payroll_UploadRefundReceiptInput', {
  _files: { type: 'array',   required: true },
})
